import { EventsManager } from "@game-libs/events-manager";
import { GUIActions } from "./types/game-types";
import { AchievementsHandler } from "@game-libs/achievements-handler";


// INIT STATS AND ACHIEVEMENTS HANDLER
const { init } = AchievementsHandler();
init();

// setTimeout(() => {
//   const { clearAchievement, setStatFloat, setStatInt } = AchievementsHandler();
//   setStatFloat('gold_collected', 0);
//   setStatInt('birds_killed', 0);
//   setStatInt('click_amount', 0);
//   clearAchievement('BIRDS_KILLED_10');
//   clearAchievement('GOLD_COLLECTED_1M');
//   clearAchievement('TOTAL_CLICKS_10000');
//   clearAchievement('ONLY_THIEVES_VICTORY');
//   clearAchievement('BEAT_TUTORIAL');
// }, 4000);

// SFX ON HOVER
const { emit } = EventsManager();
document.addEventListener('mouseover', (event) => {

  const target = (event.target as HTMLElement | null)?.closest('.hover-target') as HTMLElement | null;

  if (!target) return;

  const related = event.relatedTarget as HTMLElement | null;

  // If coming from inside the same element, ignore
  if (related && target.contains(related)) return;

  emit(GUIActions.HOVER_ITEM);

  // @ts-ignore - Steam SDK global
  if (typeof steam !== 'undefined') {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    // Steam features available
    // @ts-ignore - Steam SDK
    // @ts-ignore - Steam SDK
    (steam as any).activateOverlay('Friends');
  }
});


// SCALE TWEAKS
const dpr = window.devicePixelRatio || 1;
document.documentElement.style.setProperty('--init-game-scale', (1 / dpr).toString());



// Suppress react-focus-lock "focus-fighting" warning when multiple dialogs are open
// const originalError = console.error;
// console.error = (...args) => {
//   if (typeof args[0] === 'string' && args[0].includes('focus-fighting')) return;
//   originalError.apply(console, args);
// };

// // Production error overlay: show uncaught errors and unhandled rejections (no dev tools needed)
// (function setupErrorOverlay() {
//   const overlay = document.getElementById('error-overlay');
//   const messageEl = document.getElementById('error-overlay-message');
//   const closeBtn = document.getElementById('error-overlay-close');

//   function showError(message: string, stack?: string) {
//     const text = stack ? `${message}\n\n${stack}` : message;
//     if (messageEl) messageEl.textContent = text;
//     if (overlay) {
//       overlay.classList.remove('error-overlay--hidden');
//       overlay.setAttribute('aria-hidden', 'false');
//     }
//   }

//   function hideError() {
//     if (overlay) {
//       overlay.classList.add('error-overlay--hidden');
//       overlay.setAttribute('aria-hidden', 'true');
//     }
//   }

//   if (closeBtn) closeBtn.addEventListener('click', hideError);

//   window.onerror = (_msg, source, lineno, colno, error) => {
//     const message = error?.message ?? String(_msg);
//     const stack = error?.stack ?? (source ? `${source}:${lineno}:${colno}` : undefined);
//     showError(message, stack);
//     return false;
//   };

//   window.addEventListener('unhandledrejection', (event) => {
//     const reason = event.reason;
//     const message = reason instanceof Error ? reason.message : String(reason);
//     const stack = reason instanceof Error ? reason.stack : undefined;
//     showError(message, stack);
//   });
// })();